import React from 'react';
import PropTypes from 'prop-types';

const FormConditionalSection = ({ show, children, className }) => {
  if (!show) return null;

  return (
    <div className={`mt-3 pl-4 border-l-4 border-green-regular bg-green-50 rounded-r-md ${className}`}>
      {children}
    </div>
  );
};

FormConditionalSection.propTypes = {
  show: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

FormConditionalSection.defaultProps = {
  className: '',
};

export default FormConditionalSection;
